<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top
      >{{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <v-row>
            <v-col cols="12" md="12">
              <v-card class="mx-auto">
                <v-tabs v-model="tab" class="mt-3">
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab v-for="t in tabs" :key="t" :href="`#tab-${t}`">
                    {{ t }}
                  </v-tab>
                  <v-tab-item :value="'tab-Shift User Role'" class="pa-5">
                    <template>
                      <v-card>
                        <v-toolbar flat>
                          <v-toolbar-title>Set User Role</v-toolbar-title>
                        </v-toolbar>
                        <v-tabs vertical class="my-tabs">
                          <v-tab>
                            Show Filter Program
                          </v-tab>
                          <v-tab>
                            Show All Program
                          </v-tab>
                          <v-tab>
                            Show All Staff
                          </v-tab>
                          <v-tab-item>
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <div>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Administration"
                                      value="Administration"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Direct Care Staff"
                                      value="Direct Care Staff"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Shift Lead"
                                      value="Shift Lead"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Assistant Manager"
                                      value="Assistant Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="House Manager"
                                      value="House Manager"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Program Manager"
                                      value="Program Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Human Resources"
                                      value="Human Resources"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Client Services Manager"
                                      value="Client Services Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Program Coordinator"
                                      value="Program Coordinator"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Medical Manager"
                                      value="Medical Manager"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Executive Director"
                                      value="Executive Director"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Finance Manager"
                                      value="Finance Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Compliance Manager"
                                      value="Compliance Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Parent / Guardian"
                                      value="Parent/Guardian"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Support Coordinator"
                                      value="Support Coordinator"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Client"
                                      value="Client"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowFilter"
                                      hide-details
                                      label="Pharmacy"
                                      value="Pharmacy"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                               </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row
                                align="center"
                                justify="end"
                                class="mx-2 my-2"
                              >
                                <v-card-actions>
                                  <v-col v-if="this.alloweRolesInShowFilter.length <= 0">
                                    <v-btn
                                      color="primary"
                                      @click="saveUserSettings('showFilterProgram')"
                                      >Save</v-btn
                                    >
                                  </v-col>
                                </v-card-actions>
                                <v-card-actions>
                                  <v-col  v-if="this.alloweRolesInShowFilter.length > 0">
                                    <v-btn
                                      color="primary"
                                      @click="updateUserRolePermission('showFilterProgram')"
                                      >Update</v-btn
                                    >
                                  </v-col>
                                </v-card-actions>
                              </v-row>
                            </v-card-text>
                          </v-tab-item>
                          <v-tab-item>
                           <v-card-text>
                              <v-row>
                                <v-col>
                                  <div>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Administration"
                                      value="Administration"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Direct Care Staff"
                                      value="Direct Care Staff"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Shift Lead"
                                      value="Shift Lead"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Assistant Manager"
                                      value="Assistant Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="House Manager"
                                      value="House Manager"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Program Manager"
                                      value="Program Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Human Resources"
                                      value="Human Resources"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Client Services Manager"
                                      value="Client Services Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Program Coordinator"
                                      value="Program Coordinator"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Medical Manager"
                                      value="Medical Manager"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Executive Director"
                                      value="Executive Director"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Finance Manager"
                                      value="Finance Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Compliance Manager"
                                      value="Compliance Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Parent / Guardian"
                                      value="Parent/Guardian"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Support Coordinator"
                                      value="Support Coordinator"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Client"
                                      value="Client"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowProgram"
                                      hide-details
                                      label="Pharmacy"
                                      value="Pharmacy"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                               </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row
                                align="center"
                                justify="end"
                                class="mx-2 my-2"
                              >
                              <v-card-actions>
                                  <v-col v-if="this.alloweRolesInShowProgram.length <= 0">
                                    <v-btn
                                      color="primary"
                                      @click="saveUserSettings('showAllProgram')"
                                      >Save</v-btn
                                    >
                                  </v-col>
                                </v-card-actions>
                                <v-card-actions>
                                  <v-col  v-if="this.alloweRolesInShowProgram.length > 0">
                                    <v-btn
                                      color="primary"
                                      @click="updateUserRolePermission('showAllProgram')"
                                      >Update</v-btn
                                    >
                                  </v-col>
                                </v-card-actions>
                              </v-row>
                            </v-card-text>
                          </v-tab-item>
                          <v-tab-item>
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <div>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Administration"
                                      value="Administration"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Direct Care Staff"
                                      value="Direct Care Staff"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Shift Lead"
                                      value="Shift Lead"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Assistant Manager"
                                      value="Assistant Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="House Manager"
                                      value="House Manager"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Program Manager"
                                      value="Program Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Human Resources"
                                      value="Human Resources"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Client Services Manager"
                                      value="Client Services Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Program Coordinator"
                                      value="Program Coordinator"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Medical Manager"
                                      value="Medical Manager"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Executive Director"
                                      value="Executive Director"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Finance Manager"
                                      value="Finance Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Compliance Manager"
                                      value="Compliance Manager"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Parent / Guardian"
                                      value="Parent/Guardian"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Support Coordinator"
                                      value="Support Coordinator"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Client"
                                      value="Client"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="AllowedRolesForShowStaff"
                                      hide-details
                                      label="Pharmacy"
                                      value="Pharmacy"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                               </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row
                                align="center"
                                justify="end"
                                class="mx-2 my-2"
                              >
                                <v-card-actions>
                                  <v-col v-if="this.alloweRolesInShowStaff.length <= 0">
                                    <v-btn
                                      color="primary"
                                      @click="saveUserSettings('showAllStaff')"
                                      >Save</v-btn
                                    >
                                  </v-col>
                                </v-card-actions>
                                <v-card-actions>
                                  <v-col  v-if="this.alloweRolesInShowStaff.length > 0">
                                    <v-btn
                                      color="primary"
                                      @click="updateUserRolePermission('showAllStaff')"
                                      >Update</v-btn
                                    >
                                  </v-col>
                                </v-card-actions>
                              </v-row>
                            </v-card-text>
                          </v-tab-item>
                        </v-tabs>
                      </v-card>
                    </template>
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import Foot from "../components/Footer";
import { mapGetters, mapActions, mapState } from "vuex";
import { setProfileTimezone } from "../../utils/timezone";

const url = require("../client_config/config").url;
export default {
  components: {
    Foot,
  },
  data: () => ({
    
    userID: "",
    tab: null,
    AllowedRolesForShowFilter: [],
    AllowedRolesForShowProgram: [],
    AllowedRolesForShowStaff: [],
    AllowedRolesForTesting: [],
    alloweRolesInShowFilter:[],
    alloweRolesInShowProgram:[],
    alloweRolesInShowStaff:[],
    usersAllowedPermissionRoles: [],
    tabs: ["Shift User Role"],
  }),

  computed: {
    ...mapGetters("timezones", [
      "getTimezones",
      "getUserTimezone",
      "getDefaultTz",
    ]),
    ...mapState("timezones", ["defaultTZ"],),

    timezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setProfileTimezone(data);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    birthMenu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    anniversaryMenu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
  },

  created() {
     this.userID = localStorage.getItem("userID");
     this.getUserInfo(this.userID);
     this.getUserRolePermission();
  },

  methods: {
    ...mapActions("timezones", ["updateTimezone", "fetchUser"]),

    validate() {
      return this.$refs.form.validate();
    },

    initialize() {},
    getUserInfo: function(id) {
      axios.get(`${url}/users/${id}`).then((res) => {
        this.user = res.data.user;
        this.shiftUserRole = { ...res.data.user.shiftUserRoleAccess };  
      });
    },

    getUserRolePermission: function() {
        this.isLoading = true;
        axios.get(`${url}/userRolePermission`).then(res => {
            this.usersAllowedPermissionRoles = res.data.permission;
            this.usersAllowedPermissionRoles.map(allowedRoles => {
                console.log({allowedRoles:allowedRoles});
              if (allowedRoles.Type === 'Shift' && allowedRoles.Description === 'showFilterProgram'){
                  allowedRoles.AllowedRoles.forEach(role =>{
                    this.AllowedRolesForShowFilter.push(role);
                    this.alloweRolesInShowFilter.push(role);
                  });
              } else if (allowedRoles.Type === 'Shift' && allowedRoles.Description === 'showAllProgram'){
                allowedRoles.AllowedRoles.forEach(role =>{
                    this.AllowedRolesForShowProgram.push(role);
                    this.alloweRolesInShowProgram.push(role);
                });
              } else if (allowedRoles.Type === 'Shift' && allowedRoles.Description === 'showAllStaff') {
                allowedRoles.AllowedRoles.forEach(role =>{
                    this.AllowedRolesForShowStaff.push(role);
                    this.alloweRolesInShowStaff.push(role);
                });
              } 
            })
        }).finally(() => this.isLoading = false);
    },

    updateUserRolePermission(Description) {
        if (Description === 'showFilterProgram'){
          this.AllowedRoles = this.AllowedRolesForShowFilter;
        } else if (Description === 'showAllProgram'){
          this.AllowedRoles = this.AllowedRolesForShowProgram;
        } else if (Description === 'showAllStaff'){
          this.AllowedRoles = this.AllowedRolesForShowStaff;
        } 

        let request_body = {
        Type: 'Shift',
        Description : Description,
        AllowedRoles : this.AllowedRoles
        };

        axios.put(`${url}/userRolePermission/${'Shift'}/${Description}`, request_body).then((response) => {
          if (response.status == 400) {
            response.json().then(function(data) {
                alert(data.msg);
            });
          }
          this.msg =true;
          this.text ="User permission has been updated successfully.";
      });
    },

    saveUserSettings(Description) { 
      console.log('I am here in save'); 
      if (Description === 'showFilterProgram'){
        this.AllowedRoles = this.AllowedRolesForShowFilter;
      } else if (Description === 'showAllProgram'){
        this.AllowedRoles = this.AllowedRolesForShowProgram;
      } else if (Description === 'showAllStaff'){
        this.AllowedRoles = this.AllowedRolesForShowStaff;
      } 
      
      let request_body = {
        Type: 'Shift',
        Description : Description,
        AllowedRoles : this.AllowedRoles
      };
      axios
        .post(`${url}/userRolePermission`, request_body)
        .then((res) => {
          // this.close();
          if (res.status === 200) {
            this.text = res.data.msg;
            this.msg = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
 
  },
};
</script>
<style scoped>
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
div.my-tabs .v-icon {
  margin-right: 10px;
}
</style>
